// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__f2FP-","loaderOuter":"PageOverlayLoader_loaderOuter__2B8mU"};